import React from 'react';
import {useNavigate} from "react-router-dom";
import RatingIndicator from "../RatingIndicator";
import styles from "../../../assets/styles/cardNews/CardHorizontal.module.css";
import PressNDate from "./PressNDate";


const CardHorizontal = ({news}) => {
    const navigate = useNavigate();
    const moveToSingleNews = () => {navigate(`/single-news/${news.newsid}`)}
    const moveToTimeline = () => {navigate(`/${news.newsid}/timeline`)}

    return (
        <div  className={styles.card_container} onClick={moveToSingleNews}>
            <div className={styles.card_top}>
                <RatingIndicator signal={news.signal}  percent={news.staticsentimental.percent}/>
                <span className={styles.stockname}>{news.stockname}</span>
            </div>
            <div className={styles.card_contents}>
                <div>
                    <div className={styles.card_news}>
                        <p className={styles.title}>{news.subject}</p>
                        <p className={styles.summary}>{news.summary}</p>
                    </div>

                    <div className={styles.card_footer}>
                        {/*<span>{news.press}·{news.registdate.slice(-5)}</span>*/}
                        <PressNDate press={news.press} date={news.registdate}/>
                        {news.samenewscounts>0 && <span className={styles.newscnt} onClick={moveToTimeline}>연관뉴스 {news.samenewscounts}건 보기 > </span>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CardHorizontal;
